<div class="com-year-picker-title com-year-month-title">Month</div>
<ul class="com-month-picker-wrapper">
  <li class="com-picker-item" [ngClass]="{'com-selected-item':month.value===currentMonth,'com-disabled-item':!isValidMonth(month.value)}"
    (click)="monthClick(month.value)" *ngFor="let month of monthList">
    <span>{{month.text}}</span>
  </li>
</ul>
